import React from 'react'
import { Snackbar, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles(theme => ({
    root: {
        top: theme.spacing(9),
        '& .MuiAlert-root': {
            backgroundColor: '#ff0000',
            color: '#fff'
        },
        '& .MuiAlert-icon': {
            color: '#fff'
        }
    }
}))

export default function NotificationUsuarioInvalido(props) {

    const { notifyUsuarioInvalido, setNotifyUsuarioInvalido } = props;
    const classes = useStyles()

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotifyUsuarioInvalido({
            ...notifyUsuarioInvalido,
            isOpen: false
        })
    }

    return (
        <Snackbar
            autoHideDuration={3000}
            className={classes.root}
            open={notifyUsuarioInvalido.isOpen}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            onClose={handleClose}>
            <Alert
                onClose={handleClose}>
                {notifyUsuarioInvalido.message}
            </Alert>
        </Snackbar>
    )
}